import {SkillGroupExtendedModel} from './skillGroupExtended.model';

export class SkillGroupStrugglingStudentsModel extends SkillGroupExtendedModel {

  // The number of students struggling with the skill group
  numStrugglingStudents: number;

  static generateModel(json: any): SkillGroupStrugglingStudentsModel {

    const sGroup = new SkillGroupStrugglingStudentsModel();
    SkillGroupExtendedModel.generate(json, sGroup);
    sGroup.numStrugglingStudents = json.numStrugglingStudents;

    return sGroup;

  }

  static generateModels(jsonList: any): SkillGroupStrugglingStudentsModel[] {

    const list = [];

    for (const json of jsonList) {
      list.push(this.generateModel(json));
    }

    return list;

  }

}
